import JobSettings from "./JobSettings";
import {JOB_STATE_DRAFT, JOB_STATE_COMPLETE, JOB_COMPLETED_STATES} from "../const/job.const";
import JobFeedback from "./JobFeedback";
import JobThumbnails from "./JobThumbnails";
import {createUUID4} from "../../../../../helper/uuid";
import StageJob from "./StageJob";

export default class Job {
    id = '';
    state = JOB_STATE_DRAFT;
    feedback = {};
    stageJobs =  [];
    activeStageJob = null;

    constructor() {
        this.id = createUUID4();
        this.feedback = new JobFeedback();
        this.stageJobs.push(new StageJob());
        this.activeStageJob = this.stageJobs[0].id;
    }

    isStateCompleted() {
        return JOB_COMPLETED_STATES.includes(this.state);
    }

    getActiveStageJob() {
    return this.stageJobs.find(job => job.id === this.activeStageJob);
    }
}
